import { render } from "./ModalMain.vue?vue&type=template&id=51b7726e&scoped=true&ts=true"
import script from "./ModalMain.vue?vue&type=script&lang=ts"
export * from "./ModalMain.vue?vue&type=script&lang=ts"

import "./ModalMain.vue?vue&type=style&index=0&id=51b7726e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b7726e"]])

export default __exports__